import {
  Building2,
  FileBarChart2,
  FileText,
  KeyRound,
  Layers,
  LayoutDashboard,
  Settings,
  ShieldCheck,
  Users,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import { ACAO } from '@/utility/permissions'
import type { Acao } from '@/utility/permissions'

export interface NavItem {
  id: string
  title: string
  path: string
  icon: LucideIcon
  acao: Acao
}

export interface NavGroup {
  id: string
  title: string
  items: NavItem[]
}

export const navigation: NavGroup[] = [
  {
    id: 'inicio',
    title: 'Início',
    items: [
      {
        id: 'dashboard',
        title: 'Dashboard',
        path: '/dashboard',
        icon: LayoutDashboard,
        acao: ACAO.VerDashboard,
      },
    ],
  },
  {
    id: 'operacao',
    title: 'Operação',
    items: [
      {
        id: 'autorizacoes',
        title: 'Autorizações',
        path: '/autorizacoes',
        icon: FileText,
        acao: ACAO.VerAutorizacoes,
      },
      {
        id: 'credenciais',
        title: 'Credenciais',
        path: '/credenciais',
        icon: KeyRound,
        acao: ACAO.VerCredenciais,
      },
      {
        id: 'tipos-credenciais',
        title: 'Tipos de credencial',
        path: '/tipos-credenciais',
        icon: Layers,
        acao: ACAO.VerTiposCredenciais,
      },
      {
        id: 'relatorios',
        title: 'Relatórios',
        path: '/relatorios',
        icon: FileBarChart2,
        acao: ACAO.VerRelatorios,
      },
    ],
  },
  {
    id: 'administracao',
    title: 'Administração',
    items: [
      {
        id: 'clientes',
        title: 'Clientes',
        path: '/clientes',
        icon: Building2,
        acao: ACAO.EditarCliente,
      },
      {
        id: 'operadores',
        title: 'Operadores',
        path: '/operadores',
        icon: Users,
        acao: ACAO.GerenciarOperadores,
      },
      {
        id: 'administradores',
        title: 'Administradores',
        path: '/administradores',
        icon: ShieldCheck,
        acao: ACAO.GerenciarAdministradores,
      },
    ],
  },
  {
    id: 'conta',
    title: 'Conta',
    items: [
      {
        id: 'configuracoes',
        title: 'Configurações',
        path: '/configuracoes',
        icon: Settings,
        acao: ACAO.VerDashboard,
      },
    ],
  },
]
